import { IonicModule } from '@ionic/angular';
import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { BackButtonModule } from '../../components/back-button/back-button.component.module';
import { VaultPage } from './vault.component';
import { HeaderModule } from 'src/app/components/header/header.module';
import { VaultPromoModalComponent } from './vault-promo-modal/vault.promo.modal';
import { SafeHtmlsModule } from 'src/app/angular-wallet-base/pipes/safe-htmls/safe-htmls.module';
import { NgApexchartsModule } from 'ng-apexcharts';
import { VaultAssetComponent } from './vault-asset/vault-asset.component';
import { TabsModule } from 'src/app/components/home-page/tabs/tabs.module';
import { TransactionDetailsComponent } from './transaction-details/transaction-details.component';
import { NgxKjuaModule } from 'ngx-kjua';
import { SelectAssetModule } from '../select-asset-modal/select-asset-modal.module';
import { KycModalModule } from 'src/app/components/kyc-modal/kyc-modal.module';
import { CustomCurrencyPipeModule } from 'src/app/angular-wallet-base/pipes/customcurrency/customcurrency.module';
import { SmallToCryptoPipeModule } from '../../angular-wallet-base/pipes/smalltocrypto/smalltocrypto.module';
import { DebounceDirectiveModule } from 'src/app/angular-wallet-base/directives/debounce/debounce-directive.module';
import { CustomCurrencyPipe } from 'src/app/angular-wallet-base/pipes/customcurrency/customcurrency.pipe';
import { ImportAssetModalComponent } from './add-new-token-modal/add-new-token.modal';
import { ImportOrHideAssetModalComponent } from './import-or-hide-token-modal/import-or-hide-token.modal';
import { LongPressDirectiveModule } from 'src/app/angular-wallet-base/directives/long-press/long-press-directive.module';
import { MatSelectModule } from '@angular/material/select';

const routes: Routes = [
  {
    path: '',
    component: VaultPage,
  },
  { path: 'tranDetails', component: TransactionDetailsComponent },
  { path: 'token-page', component: VaultAssetComponent },
];
@NgModule({
  imports: [
    IonicModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    TabsModule,
    RouterModule.forChild(routes),
    BackButtonModule,
    HeaderModule,
    SafeHtmlsModule,
    NgApexchartsModule,
    NgxKjuaModule,
    SelectAssetModule,
    KycModalModule,
    CustomCurrencyPipeModule,
    SmallToCryptoPipeModule,
    DebounceDirectiveModule,
    LongPressDirectiveModule,
    MatSelectModule,
  ],
  declarations: [
    VaultPage,
    VaultPromoModalComponent,
    VaultAssetComponent,
    TransactionDetailsComponent,
    ImportAssetModalComponent,
    ImportOrHideAssetModalComponent,
  ],
  providers: [CustomCurrencyPipe],
})
export class VaultModule {}
